import isProd from "./variabels";
const mocosdk = require("@mocobaas/client-js");
const client = new mocosdk.init(isProd.apiUrl);
// const client = new mocosdk.init("http://localhost:3000");

export default client;
